var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 15,
    height: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57541 9.76572C7.62322 9.76572 6.78559 9.26826 6.30702 8.52002H0.393066V17.1818H16.7578V8.52002H10.8438C10.3652 9.26826 9.5276 9.76572 8.57541 9.76572ZM5.13435 15.066H2.95897V10.6359H3.91784V14.1071H5.13435V15.066ZM6.72659 15.0674H5.76772V10.6344H6.72659V15.0674ZM11.7825 10.6503H14.1919V11.6091H12.7414V12.3715H14.0849V13.3303H12.7414V14.0927H14.1919V15.0515H11.7825V10.6503ZM9.76268 15.1128L8.95503 15.112L7.36238 10.9303L8.25844 10.589L9.35673 13.4727L10.4447 10.5899L11.3418 10.9284L9.76268 15.1128Z",
    fill: "#EB4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57535 8.80671C9.53223 8.80671 10.3079 8.03101 10.3079 7.07413C10.3079 6.11726 9.53223 5.34155 8.57535 5.34155C7.61848 5.34155 6.84277 6.11726 6.84277 7.07413C6.84277 8.03101 7.61848 8.80671 8.57535 8.80671Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91432 1.55058L3.29524 0.818359C1.45086 2.3778 0.393066 4.6561 0.393066 7.06919H1.35194C1.3519 4.93887 2.28587 2.92742 3.91432 1.55058Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27772 7.06891C3.27772 5.50653 3.9627 4.03132 5.15703 3.02153L4.53796 2.28931C3.12769 3.48169 2.31885 5.2238 2.31885 7.06895L3.27772 7.06891Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2035 7.06885C5.2035 6.07444 5.63949 5.13548 6.39965 4.49269L5.78054 3.7605C4.80445 4.58586 4.24463 5.7917 4.24463 7.06885H5.2035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7987 7.06895H16.7576C16.7576 4.65586 15.6998 2.37756 13.8554 0.818115L13.2363 1.55034C14.8647 2.92721 15.7987 4.93866 15.7987 7.06895Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.873 7.06895H14.8318C14.8318 5.22383 14.023 3.48172 12.6127 2.28931L11.9937 3.02153C13.188 4.03138 13.873 5.5066 13.873 7.06895Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9476 7.06885H12.9065C12.9065 5.7917 12.3467 4.58583 11.3706 3.7605L10.7515 4.49269C11.5116 5.13548 11.9476 6.07447 11.9476 7.06885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.e5115ebe126802cd86977b835430d1ae.svg";
export { ForwardRef as ReactComponent };